export default "/awstETH.ef2f4798fbb304c0498d7f5674df8955.png";